import { createContext, useContext, Dispatch } from 'react';

import { PlusOneModalState, PlusOneModalAction } from './plusOneModalReducer';

interface PlusOneGuestModalContextValue {
  state: PlusOneModalState;
  dispatch: Dispatch<PlusOneModalAction>;
  handleFinalSubmit: (sendNotifications: boolean) => void;
  handleRemoveGuest: () => void;
  savingPlusOneGuest: boolean;
  removingPlusOneGuest: boolean;
  settingSessionPlusOneGuests: boolean;
}

const PlusOneGuestModalContext = createContext<PlusOneGuestModalContextValue | null>(null);

export const PlusOneGuestModalProvider = PlusOneGuestModalContext.Provider;

export const usePlusOneGuestModalContext = (): PlusOneGuestModalContextValue => {
  const context = useContext(PlusOneGuestModalContext);
  if (!context) {
    throw new Error('usePlusOneGuestModalContext must be used within a PlusOneGuestModalProvider');
  }
  return context;
};
